import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useLocation } from "react-router-dom";
import SchoolInnerPageBanner from "../../components/SchoolInnerPageBanner";
const baseAPIUrl = process.env.REACT_APP_API_BASE_URL;

const SchoolAboutPage = () => {
  const location = useLocation();
  const { school_slug } = useParams();
  const [mv, setMv] = useState(null);

  const [affiliation, setAffiliation] = useState(null);
  const [awards, setAwards] = useState(null);
  const [csr, setCsr] = useState(null);
  const [mentorship, setMentorship] = useState(null);

  const [about, setAbout] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // For scroll top

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    const sectionId = location.state?.scrollTo;
    if (!sectionId) return;

    const timer = setTimeout(() => {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 150);

    return () => clearTimeout(timer);
  }, [location.key]);

  useEffect(() => {
    scrollToTop();
  }, []);

  /* ---------------- FETCH ABOUT DATA ---------------- */

  useEffect(() => {
    if (!school_slug) return;

    setLoading(true);
    setError("");

    axios
      .get(`${baseAPIUrl}api/about/${school_slug}`)
      .then((res) => {
        if (
          res.data.status === 1 &&
          res.data.data &&
          (res.data.data.heading ||
            res.data.data.paragraph_1 ||
            res.data.data.paragraph_2 ||
            res.data.data.paragraph_3)
        ) {
          setAbout(res.data.data);
        } else {
          setAbout(null);
        }
      })
      .catch(() => setAbout(null));
  }, [school_slug]);

  /* ---------------- FETCH MISSION VISION DATA ---------------- */
  useEffect(() => {
    if (!school_slug) return;

    axios
      .get(`${baseAPIUrl}api/about/mission_vision/${school_slug}`)
      .then((res) => {
        if (
          res.data.status === 1 &&
          res.data.data &&
          (
            res.data.data.mission_content ||
            res.data.data.vission_content
          )
        ) {
          setMv(res.data.data);
        } else {
          setMv(null); // ❌ hide section
        }
      })
      .catch(() => setMv(null));
  }, [school_slug]);

  /* ---------------- FETCH AFFILIATIONS DATA ---------------- */
  useEffect(() => {
    if (!school_slug) return;

    axios
      .get(`${baseAPIUrl}api/about/affiliations/${school_slug}`)
      .then((res) => {
        if (
          res.data.status === 1 &&
          res.data.data &&
          (
            res.data.data.section?.heading ||
            res.data.data.section?.paragraph_1 ||
            res.data.data.rows?.length > 0
          )
        ) {
          setAffiliation(res.data.data);
        } else {
          setAffiliation(null); // ❌ hide section
        }
      })
      .catch(() => setAffiliation(null));
  }, [school_slug]);

  /* ---------------- FETCH ACCOLADES & AWARDS DATA ---------------- */
  useEffect(() => {
    axios
      .get(`${baseAPIUrl}api/about/awards/${school_slug}`)
      .then((res) => {
        if (
          res.data.status === 1 &&
          res.data.data &&
          (
            res.data.data.section?.heading ||
            res.data.data.section?.intro_text ||
            res.data.data.items?.length > 0
          )
        ) {
          setAwards(res.data.data);
        } else {
          setAwards(null); // ❌ hide section
        }
      })
      .catch(() => setAwards(null));
  }, [school_slug]);

  /* ---------------- FETCH CSR DATA ---------------- */
  useEffect(() => {
    if (!school_slug) return;

    axios
      .get(`${baseAPIUrl}api/about/csr/${school_slug}`)
      .then((res) => {
        if (res.data.status === 1) {
          setCsr(res.data.data);
        } else {
          setCsr(null);
        }
      })
      .catch((err) => {
        console.error("CSR API ERROR:", err);
        setCsr(null);
      });
  }, [school_slug]);

  /* ---------------- FETCH MENTORSHIP DATA ---------------- */
  useEffect(() => {
    if (!school_slug) return;

    axios
      .get(`${baseAPIUrl}api/about/mentorship/${school_slug}`)
      .then((res) => {
        if (res.data.status === 1) {
          setMentorship(res.data.data);
        } else {
          setMentorship(null);
        }
      })
      .catch((err) => {
        console.error("MENTORSHIP API ERROR:", err);
        setMentorship(null);
      });
  }, [school_slug]);

  // For About

  const hasAboutContent =
    !!about &&
    (
      about.heading ||
      about.paragraph_1 ||
      about.paragraph_2 ||
      about.paragraph_3 ||
      about.about_section_image
    );

  // For Mission & Vision and affiliation

  const hasMv =
    !!mv &&
    (mv.vission_content || mv.mv_image);

  const hasAffiliation =
    !!affiliation &&
    affiliation.section &&
    (
      affiliation.section.heading ||
      affiliation.section.paragraph_1 ||
      affiliation.rows?.length > 0
    );

  // For Accolades & awards

  const hasAwards =
    !!awards &&
    awards.section &&
    (
      awards.section.heading ||
      awards.items?.length > 0 ||
      awards.section.highlight_text
    );

  // For CSR

  const hasCsr =
    !!csr &&
    csr.section &&
    (
      csr.section.heading ||
      csr.blocks?.length > 0 ||
      csr.images?.length > 0
    );


  // For Mentorship
  const hasMentorship =
    !!mentorship &&
    mentorship.section &&
    mentorship.section.heading;


  return (
    <>
      {/* 🔹 SCHOOL HEADER */}
      <div>
        <SchoolInnerPageBanner />

        {/* 🔹 ABOUT SECTION */}
        {hasAboutContent && (
          <section id="about-us"
            style={{
              padding: "80px 20px",
              background: "rgb(100, 19, 32)",
              color: "white",
            }}
          >
            <div className="container" style={{ maxWidth: "1200px", margin: "0 auto" }}>
              <div className="row align-items-center">

                {/* TEXT */}
                <div className="col-lg-8">
                  {about?.heading && (
                    <h1
                      style={{
                        fontSize: "2.5rem",
                        marginBottom: "30px",
                        fontFamily: "Lora",
                      }}
                    >
                      {about?.heading}
                    </h1>
                  )}

                  {about?.paragraph_1 && <p>{about.paragraph_1}</p>}
                  {about?.paragraph_2 && <p>{about.paragraph_2}</p>}
                  {about?.paragraph_3 && <p>{about.paragraph_3}</p>}
                </div>

                {/* IMAGE */}
                {about?.about_section_image && (
                  <div className="col-lg-4">
                    <img
                      src={about.about_section_image}
                      alt={about.heading || "About"}
                      style={{ width: "100%", borderRadius: "10px" }}
                      onError={(e) => (e.target.style.display = "none")}
                    />
                  </div>
                )}
              </div>

              {hasMv &&
                mv.heading &&
                (mv.mission_content || mv.vission_content) && (
                  <div className="mv-wrapper">

                    {/* Mission */}
                    {mv.mission_content && (
                      <div className="mv-box">
                        <h3 style={{ fontFamily: "Lora" }}>Mission</h3>
                        <ul style={{ listStyle: "none", padding: 0 }}>
                          {mv.mission_content.split("\n").map((item, i) => (
                            <li key={i}>• {item}</li>
                          ))}
                        </ul>
                      </div>
                    )}

                    {/* Vision */}
                    {mv.vission_content && (
                      <div className="mv-box">

                        <h3 style={{ fontFamily: "Lora" }}>Vision</h3>
                        <ul style={{ listStyle: "none", padding: 0 }}>
                          {mv.vission_content.split("\n").map((item, i) => (
                            <li key={i}>• {item}</li>
                          ))}
                        </ul>
                      </div>
                    )}

                  </div>
                )}
            </div>
          </section>
        )}

        {/*--------- Affiliations and Certifications Section ------*/}
        {hasAffiliation &&
          (
            affiliation.section.paragraph_1 ||
            affiliation.section.paragraph_2 ||
            affiliation.section.paragraph_3 ||
            affiliation.rows?.length > 0
          ) && (
            <section id="affiliations-and-certifications" style={{ padding: '80px 20px', background: '#fff'}}>
              <div style={{ maxWidth: '1200px', margin: '0 auto' }}>

                <h2 style={{ fontSize: '2.5rem', textAlign: 'center', marginBottom: '30px', fontFamily: 'Lora', color: 'rgb(100, 19, 32)', fontWeight: '600' }}>
                  {affiliation.section.heading}
                </h2>

                {affiliation.section.paragraph_1 && (
                  <p style={{ marginBottom: '20px' }}>
                    {affiliation.section.paragraph_1}
                  </p>
                )}

                {affiliation.section.paragraph_2 && (
                  <p style={{marginBottom: '20px' }}>
                    {affiliation.section.paragraph_2}
                  </p>
                )}

                {affiliation.section.paragraph_3 && (
                  <p style={{marginBottom: '40px'}}>
                    {affiliation.section.paragraph_3}
                  </p>
                )}

                {/* TABLE */}
                {affiliation.rows && affiliation.rows.length > 0 && (
                  <div style={{ overflowX: 'auto', marginBottom: '30px' }}>
                    <table style={{
                      width: '100%', minWidth: '600px', maxWidth: '800px', margin: '0 auto', backgroundColor: 'rgb(100, 19, 32)', color: '#333', borderRadius: '10px', overflow: 'hidden', fontFamily: 'Lora', border: '2px solid #333', borderCollapse: 'collapse'

                    }}>
                      <thead>
                        <tr style={{ backgroundColor: 'rgb(100, 19, 32)' }}>
                          <th style={{ padding: '12px 8px', textAlign: 'center', fontWeight: '600', border: '1px solid #fff', fontSize: 'clamp(0.75rem, 2vw, 0.9rem)', color: '#fff', whiteSpace: 'nowrap' }}>SL</th>
                          <th style={{ padding: '12px 8px', textAlign: 'center', fontWeight: '600', border: '1px solid #fff', fontSize: 'clamp(0.75rem, 2vw, 0.9rem)', color: '#fff', whiteSpace: 'nowrap' }}>SCHOOL</th>
                          <th style={{ padding: '12px 8px', textAlign: 'center', fontWeight: '600', border: '1px solid #fff', fontSize: 'clamp(0.75rem, 2vw, 0.9rem)', color: '#fff', whiteSpace: 'nowrap' }}> CLASS</th>
                          <th style={{ padding: '12px 8px', textAlign: 'center', fontWeight: '600', border: '1px solid #fff', fontSize: 'clamp(0.75rem, 2vw, 0.9rem)', color: '#fff', whiteSpace: 'nowrap' }}>AFFILIATION NO</th>
                        </tr>
                      </thead>

                      <tbody>
                        {affiliation.rows.map((row, index) => (
                          <tr key={index}>
                            <td style={{ padding: '10px 8px', textAlign: 'center', border: '1px solid #fff', color: '#fff', fontSize: 'clamp(0.7rem, 2vw, 0.85rem)', fontFamily: 'Metropolis-Regular' }}>{index + 1}</td>
                            <td style={{ padding: '10px 8px', textAlign: 'center', border: '1px solid #fff', color: '#fff', fontSize: 'clamp(0.7rem, 2vw, 0.85rem)', whiteSpace: 'nowrap', fontFamily: 'Metropolis-Regular' }}>{row.school_name}</td>
                            <td style={{ padding: '10px 8px', textAlign: 'center', border: '1px solid #fff', color: '#fff', fontSize: 'clamp(0.7rem, 2vw, 0.85rem)', whiteSpace: 'nowrap', fontFamily: 'Metropolis-Regular' }}>{row.class_range}</td>
                            <td style={{ padding: '10px 8px', textAlign: 'center', fontWeight: '600', color: '#fff', border: '1px solid #fff', fontSize: 'clamp(0.7rem, 2vw, 0.85rem)', fontFamily: 'Metropolis-Regular' }}>{row.affiliation_no}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}

                {affiliation.section.paragraph_after_table && (
                  <p style={{ fontSize: "1.1rem", lineHeight: "1.8" }}>
                    {affiliation.section.paragraph_after_table}
                  </p>
                )}

              </div>
            </section>
          )}

        {/*------- Our Programs towards the CSR Section ------ */}
        {hasCsr && (
          <section id="our-programs-towards-the-society" style={{ padding: "80px 20px", background: "rgb(100, 19, 32)" }}>
            <div style={{ maxWidth: '1200px', margin: '0 auto' }}>

              <h2 style={{ fontSize: '2.5rem', textAlign: 'center', color: '#fff', marginBottom: '50px', fontFamily: 'Lora' }}>{csr.section.heading}</h2>
              <h3 style={{ fontSize: '1.8rem', color: '#fff', marginBottom: '20px', fontFamily: 'Lora' }}>{csr.section.intro_heading}</h3>
              <p style={{ color: '#fff', marginBottom: '25px' }}>{csr.section.intro_paragraph}</p>

              {csr.blocks.map((item, idx) => (
                <div key={idx}>
                  <h4 style={{ fontSize: '1.4rem', fontWeight: '600', marginBottom: '15px', fontFamily: 'Lora', color: '#fff' }}>{item.block_heading}</h4>
                  <p style={{ marginBottom: '25px', color: '#fff' }}>{item.block_content}</p>
                </div>
              ))}

              <p style={{ marginBottom: '40px', color: '#fff' }}>{csr.section.last_paragraph}</p>


              <div className="row">
                {csr.images.map((img, i) => (
                  <div key={i} className="col-md-4 mb-3">
                    <img src={img.image_name} style={{ width: '100%', borderRadius: '10px', boxShadow: '0 8px 20px rgba(255, 255, 255, 0.3)' }} />
                  </div>
                ))}
              </div>

            </div>
          </section>
        )}

      </div>
    </>
  );
};

export default SchoolAboutPage;
